import {
  FETCH_ADMIN_QUEUE_ADDON,
  FETCH_ADMIN_QUEUE_ADDON_SUCCESS,
  FETCH_ADMIN_QUEUE_ADDON_FAILED,
  EDIT_ADMIN_QUEUE_ADDON,
  CLEAR_ADMIN_QUEUE_ADDON_ERROR
} from "../store/types";

const INITIAL_STATE = {
  data: null,
  error: null,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ADMIN_QUEUE_ADDON:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ADMIN_QUEUE_ADDON_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null
      };
    case FETCH_ADMIN_QUEUE_ADDON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case EDIT_ADMIN_QUEUE_ADDON:
      return {
        ...state,
        data: action.payload
      };
    case CLEAR_ADMIN_QUEUE_ADDON_ERROR:
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};
